// remove core routes from saffron core, by overriding with an empty module
export default [


];
